import { type FC, memo, useMemo } from 'react';
import classNames from 'classnames';
import parse from 'html-react-parser';
import { isEmpty, isNil } from 'lodash';
// Import Services
import { sanitizeSvg } from 'services/html';
// Import Styles
import styles from './customerJourneyVisualizationIcon.module.scss';

interface Props {
    svg?: Nilable<string>;
    className?: string;
}

const CustomerJourneyVisualizationIcon: FC<Props> = ({ svg = null, className }) => {
    // The SVG comes from a partner/application setting, so it is data: sanitized before it becomes React nodes
    const iconNode = useMemo(() => {
        const safeSvg = sanitizeSvg(svg).trim();

        return isEmpty(safeSvg) ? null : parse(safeSvg);
    }, [svg]);

    if (isNil(iconNode)) {
        return null;
    }

    return <span className={classNames('crm-option-icon-column', styles.icon, className)}>{iconNode}</span>;
};

CustomerJourneyVisualizationIcon.displayName = 'CustomerJourneyVisualizationIcon';

export default memo(CustomerJourneyVisualizationIcon);
